import { SmartDataTable } from '@src/components/SmartDataTable';
import { useBranchesColumns, useBranchesFormFields } from './hooks';

export const BranchesList = () => {
  const columns = useBranchesColumns();
  const formFields = useBranchesFormFields();

  return (
    <SmartDataTable
      api={{
        resource: 'branches',
      }}
      title="Branches"
      columns={columns}
      search={{
        enabled: true,
        fields: ['name'],
        placeholder: 'Search by branch name...',
        debounceMs: 500,
      }}
      createForm={{
        fields: formFields as any,
        title: 'Create Branch',
        submitText: 'Create Branch',
      }}
      editForm={{
        fields: formFields as any,
        title: 'Edit Branch',
        submitText: 'Save Changes',
      }}
      formDisplayMode="modal"
      showCreate={true}
      showEdit={true}
      showDelete={true}
      showView={false}
      isFilter={false}
      pageSize={10}
      showSizeChanger={true}
      showQuickJumper={false}
      // showExport={true}
      showColumnVisibility={true}
      tableProps={{
        scroll: {
          x: 'max-content',
          y: 'calc(100vh - 240px)',
        },
      }}
      rowKey="id"
    />
  );
};
